class AuthService {
  // With HttpOnly cookies, the client is no longer responsible for storing/decoding tokens.
  // Keep minimal helpers for app logic that previously relied on this API shape.

  loggedIn() {
    // Unknown without a client-readable token; let app derive via querying `user` on app load.
    return false;
  }

  setToken() {
    // No-op: tokens are cookie-based now
  }

  getToken() {
    return null;
  }

  getDecryptedToken() {
    return null;
  }

  login() {
    // No-op: login now sets cookies via REST
  }

  logout() {
    // Reset app state; cookies cleared via REST /api/auth/logout when you migrate logout
    sessionStorage.setItem("contextUserId", "");
    sessionStorage.setItem("contextProduct", 0);
    sessionStorage.removeItem("transactionType");
    sessionStorage.removeItem("assetType");
    sessionStorage.removeItem("feeType");
    sessionStorage.removeItem("entityType");
  }
}

export default new AuthService();
